import React from "react";
import Header from "../../components/Header";
import PainelApropriador from "../../components/Paineis/PainelApropriador/index";
import {Context} from "../../AppProvider";
import { useLocation } from "react-router-dom";

import "./styles.css"


const  TelaPainelApropriador  = (props) => {
    const {state} = useLocation();
    let painel = state.painel;

    return (
      <Context.Consumer>
          {(context) => (
              <div>
                  <Header usuario={context.usuario} videoajuda={props.videoajuda} painel={painel} />
                  <PainelApropriador
                      metamodeloAvaliativo={context.metamodeloAvaliativo}
                      painel={painel}
                      usuario={context.usuario}
                  />
              </div>
          )}
      </Context.Consumer>
  );
}

export default TelaPainelApropriador;

